export enum OpTypes {
  CREATE_USER = 'CREATE_USER',
  INVITE_NEW_USER = 'INVITE_NEW_USER',
  ADD_EXISTING_USER = 'ADD_EXISTING_USER',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_USER = 'DELETE_USER',
  CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD',
  FAILED = 'Failed',
  RESEND_INVITE = 'RESEND_INVITE',
  DELETE_INVITE = 'DELETE_INVITE'
}

export interface Operations {
  [key: string]: {
    type: OpTypes;
    error: Error | null;
  };
}
